module.exports = __webpack_public_path__ + "static/media/Cuba-alert.901664a7.svg";